import React, { lazy, Suspense } from "react";
import { deepClone, showToast, errorHandler } from "../../../helper-methods";
import {
  getAgentClosingBidDetail,
  agentAcceptOrRejectBidding,
  agentCounterBidding,
  agentAcceptOrRejectBiddingNew,
  agentCounterBiddingNew,
  getSecondaryAgents,
  bidSentToOtherAgents,
} from "../../../http/http-calls";
import { connect } from "react-redux";
import { showLoader, hideLoader } from "../../../redux/actions/loader-data";
import { HeaderEventEmitter } from "../../../helper-methods/HeaderEvents";
import ScreenWidthHOC from "./ScreenWidthHOC";
const BiddingDetails = lazy(() => import("../components/BiddingDetails"));

class NewClosingAgent extends React.Component {
  state = {
    closingDetails: null,
    loading: false,
    isOpenCounterForm: false,
    isShareOtherAgentBtnShow: false,
    secondaryAgents: [],
    isOpenConformationModal: false,
  };

  _redirectToDashboard = (e) => {
    if (e) e.preventDefault();
    const { userData } = this.props;
    this.props.history.push(`/${userData.type}/dashboard`);
  };

  componentDidMount = async () => {
    // console.log("serfgfds", this.props.match.params);
    try {
      const id = this.props.match.params.id.replace("&guestuser", "");
      this.props.showLoader("Fetching Closing Details...");

      const res = await this._getAgentClosingBidDetail(id);
      if (!res?.error) {
        // Check that this agent is primary agent only for agent website
        // Do not call if res?.isFreeBookingWebsiteClosing
        if (
          this.props.userData.user.id === res?.closing?._websiteAgent &&
          !res?.closing?.isFreeBookingWebsiteClosing
        ) {
          // fetch for secondary agents
          const isSecondaryAgentAvailable = await this._fetchForSecondaryAgents(
            this.props.userData.user.id,
            res?.closing?._id
          );
          // console.log("res _fetchForSecondaryAgents", response);
          this.setState({
            isShareOtherAgentBtnShow: isSecondaryAgentAvailable,
          });
        }
      }

      this.props.hideLoader();
    } catch (error) {
      errorHandler(error);
      this.props.hideLoader();
      this._redirectToDashboard();
    }
  };

  _fetchForSecondaryAgents = (id, closingId) => {
    return new Promise(async (resolve, reject) => {
      const payload = {
        closingId: closingId,
      };
      try {
        const res = await getSecondaryAgents(id, payload);
        if (!res?.error) {
          if (res?.agents?.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
          this.setState({
            secondaryAgents: res?.agents || [],
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    });
  };

  _bidSentToOtherAgents = async () => {
    this.props.showLoader("Sending Bids...");
    try {
      const payload = {
        closingId: this.state.closingDetails?.id,
        agentIds: this.state.secondaryAgents,
        agentId: this.props.userData.user.id,
      };

      const response = await bidSentToOtherAgents(payload);
      if (!response?.error) {
        this.props.hideLoader();
        showToast(
          `Bid sent sunscessfully to ${this.state?.secondaryAgents?.length} agents`,
          "success"
        );
      }
    } catch (error) {
      this.props.hideLoader();
      errorHandler(error);
    }
  };

  _getAgentClosingBidDetail = (id = null) => {
    const { userData } = this.props;

    if (!id && this.state.closingDetails && this.state.closingDetails.id) {
      id = this.state.closingDetails.id;
    }
    const parts = this.props.match.params.id.split("&");

    const payload = {
      closingId: parts[0],
      agentId: this.props.userData.user.id,
    };

    return new Promise((resolve, reject) => {
      getAgentClosingBidDetail(payload)
        .then((res) => {
          this.setState(
            {
              closingDetails: res.closing,
            },
            () => {
              HeaderEventEmitter.dispatch("closing-details", {
                closingDetails: res.closing,
              });
            }
          );
          if (res?.closing?._agent !== undefined) {
            showToast("Job no longer available", "error");
            this.props.history.push(`/${userData.type}/dashboard`);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  _agentAcceptOrRejectBidding = async (
    status,
    isTermsAndConditionsAccepted = false
  ) => {
    try {
      this.setState({ loading: true });

      const payload = {
        status,
        closingId: this.state.closingDetails?.id,
        agentId: this.props.userData.user.id,
        isTermsAndConditionsAccepted: isTermsAndConditionsAccepted, // need to accept terms and conditions to accept / counter bids
      };

      if (
        this.state.closingDetails?.isAgentWebsiteClosing ||
        this.state.closingDetails?.isFreeBookingWebsiteClosing
      ) {
        await agentAcceptOrRejectBiddingNew(payload);
      } else {
        await agentAcceptOrRejectBidding(payload);
      }

      this.setState({ loading: false });
      showToast(`Order ${status}`, "success");
      this._redirectToDashboard();
    } catch (err) {
      this.setState({ loading: false });
      errorHandler(err);
    }
  };

  _onSubmitCounterOffer = async (e, childPayload) => {
    try {
      if (e) e.preventDefault();

      // no need to validate payload here as it is already validated in the child, only check if childPayload is coming or not

      if (childPayload) {
        this.setState({ loading: true });

        const { closingDetails } = deepClone(this.state);

        let payload = {
          ...childPayload,
          agentId: this.props.userData?.user?.id,
        };

        if (
          closingDetails?.isAgentWebsiteClosing ||
          closingDetails?.isFreeBookingWebsiteClosing
        ) {
          await agentCounterBiddingNew(payload);
        } else {
          await agentCounterBidding(payload);
        }
        this.setState({ loading: false });
        showToast(`Order counter offer has been sent.`, "success");
        this._redirectToDashboard();
      }
    } catch (error) {
      this.setState({ loading: false });
      errorHandler(error);
    }
  };

  _toggleConformationModal = (value) => {
    this.setState({
      isOpenConformationModal: !this.state.isOpenConformationModal,
    });

    console.log("Call >>", value);

    if (value) {
      this._bidSentToOtherAgents();
      console.log("Call _bidSentToOtherAgents >>");
    }
  };

  render() {
    const {
      closingDetails,
      loading,
      counterForm,
      // isOpenCounterForm,
      isOpenConformationModal,
      isShareOtherAgentBtnShow,
    } = this.state;

    return (
      <Suspense fallback="Loading...">
        <BiddingDetails
          closingDetails={closingDetails}
          loading={loading}
          counterForm={counterForm}
          isOpenConformationModal={isOpenConformationModal}
          isShareOtherAgentBtnShow={isShareOtherAgentBtnShow}
          agentAcceptOrRejectBidding={this._agentAcceptOrRejectBidding}
          onChangeCounterFormField={this._onChangeCounterFormField}
          onSubmitCounterOffer={this._onSubmitCounterOffer}
          toggleConformationModal={this._toggleConformationModal}
        />
      </Suspense>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: state.userData ? state.userData : {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: (text) => dispatch(showLoader(text)),
    hideLoader: () => dispatch(hideLoader()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScreenWidthHOC(NewClosingAgent));
